import ApplicantAvatars from './ApplicantAvatars'

export default ApplicantAvatars
